import {Component, EventEmitter, Input, Output} from '@angular/core';
import { IdexService } from 'app/idex.service';

@Component({
   selector: 'app-properties',
   templateUrl: './properties.component.html',
   styleUrls: ['./properties.component.css']
})
export class PropertiesComponent {
   @Output() clickDelete = new EventEmitter<any>();
   @Output() selectPositionTypeChange = new EventEmitter<any>();
   @Output() selectPageTypeChange = new EventEmitter<any>();
   @Output() checkBoxChange = new EventEmitter<any>();
   @Output() selectCertChange = new EventEmitter<any>();
   @Output() selectFileuploadChange = new EventEmitter<any>();
   @Output() fontDetailTypeChange = new EventEmitter<any>();
   @Input() isHideDeleteBtn: any;
   @Input() isHideRequire: any;
   @Input() isHideProperties: any;
   @Input() positionType: any;
   @Input() pageType: any;
   @Input() fieldType: any;
   @Input() chkName: boolean;
   @Input() chkDate: boolean;
   @Input() chkApplyAll: boolean;
   @Input() isDisabledChk: boolean;
   @Input() certId: any;
   @Input() fontDetail: any;

   fonts = [
      {value: 'THSarabunNew',viewValue: 'THSarabunNew'},
      {value: 'Kanit', viewValue: 'Kanit'},
      {value: 'Prompt', viewValue: 'Prompt'},
      {value: 'Sarabun', viewValue: 'Sarabun'},
      {value: 'Chakra Petch', viewValue: 'Chakra Petch'},
      {value: 'Mali', viewValue: 'Mali'},
      {value: 'Taviraj', viewValue: 'Taviraj'},
      {value: 'Mitr', viewValue: 'Mitr'},
      {value: 'Sriracha', viewValue: 'Sriracha'},
      {value: 'Bai Jamjuree', viewValue: 'Bai Jamjuree'},
      {value: 'Itim', viewValue: 'Itim'},
      {value: 'Noto Sans Thai', viewValue: 'Noto Sans Thai'},
      {value: 'Niramit', viewValue: 'Niramit'},
      {value: 'Krub', viewValue: 'Krub'},
      {value: 'Pridi', viewValue: 'Pridi'},
      {value: 'Athiti', viewValue: 'Athiti'},
      {value: 'Charm', viewValue: 'Charm'},
      {value: 'Pattaya', viewValue: 'Pattaya'},
      {value: 'K2D', viewValue: 'K2D'},
      {value: 'Maitree', viewValue: 'Maitree'},
      {value: 'Trirong', viewValue: 'Trirong'},
      {value: 'Chonburi', viewValue: 'Chonburi'},
      {value: 'Thasadith', viewValue: 'Thasadith'},
      {value: 'KoHo', viewValue: 'KoHo'},
      {value: 'Kodchasan', viewValue: 'Kodchasan'},
      {value: 'Fahkwang', viewValue: 'Fahkwang'},
      {value: 'IBM Plex Sans Thai', viewValue: 'IBM Plex Sans Thai'},
      {value: 'Charmonman', viewValue: 'Charmonman'},
      {value: 'Noto Serif Thai', viewValue: 'Noto Serif Thai'},
      {value: 'IBM Plex Sans Thai Looped', viewValue: 'IBM Plex Sans Thai Looped'},
      {value: 'Srisakdi', viewValue: 'Srisakdi'},
      {value: 'Noto Sans Thai Looped', viewValue: 'Noto Sans Thai Looped'}
   ];
   userCert = [];

   constructor(public service: IdexService) {
      this.onSortFonts();
   }

   loadDdlData(): void {
      this.service.get('cert/list')
      .subscribe(data => {
         if (data) {
            this.userCert = data;
         }
      });
   }

   onClickDelete() {
      this.clickDelete.emit({fieldType: this.fieldType});
   }

   onSelectPositionTypeChange($event) {
      this.selectPositionTypeChange.emit($event.value);
   }

   onSelectPageTypeChange($event) {
      this.selectPageTypeChange.emit($event.value);
   }

   onSelectCertChange($event) {
      this.selectCertChange.emit($event.value);
   }

   onFontDetailTypeChange($event) {
      this.fontDetailTypeChange.emit($event);
   }

   onCheckboxIncludeChange($event) {
      const val = {
         'chkName': this.chkName,
         'chkDate': this.chkDate,
         'chkApplyAll': this.chkApplyAll
      };
      this.checkBoxChange.emit(val);
   }

   onTextStyleChange() {
      this.onFontDetailTypeChange(this.fontDetail)
   }

   onDragOver($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $event.dataTransfer.effectAllowed = 'none';
      $event.dataTransfer.dropEffect = 'none';
   }

   onSelectFileuploadChange($event){
      this.selectFileuploadChange.emit($event);
   }

   onClickBold() {
      this.fontDetail.fontBold = !this.fontDetail.fontBold;
      this.onTextStyleChange();
   }

   onClickItalic() {
      this.fontDetail.fontItalic = !this.fontDetail.fontItalic;
      this.onTextStyleChange();
   }

   onClickUnderline() {
      this.fontDetail.fontUnderline = !this.fontDetail.fontUnderline;
      this.onTextStyleChange();
   }

   onSortFonts(){
      this.fonts.sort((a, b) => {
         const fontA = a.viewValue.toUpperCase();
         const fontB = b.viewValue.toUpperCase();
         if (fontA < fontB) {
            return -1;
         }
         if (fontA > fontB) {
            return 1;
         }
         return 0;
      });
   }
}
